module.exports = __webpack_public_path__ + "img/vouchers405.43d0b97d.png";